import { render, staticRenderFns } from "./protocolManage.vue?vue&type=template&id=19effd4c&scoped=true"
import script from "./protocolManage.vue?vue&type=script&lang=js"
export * from "./protocolManage.vue?vue&type=script&lang=js"
import style0 from "./protocolManage.vue?vue&type=style&index=0&id=19effd4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19effd4c",
  null
  
)

export default component.exports